export const webFontList = [
    'AKIRO',
    'Alfa Slab One',
    'Amatic SC',
    'AMONE',
    'Asterisma',
    'Bad Script',
    'BenchNine',
    'Biryani',
    'Bird-House',
    'Black Ops One',
    'Bite Hard',
    'Bite Hard Base',
    'Brown',
    'Bungee Shade',
    'Changa One',
    'Cinzel',
    'City-Scrawl',
    'Clarkson Script',
    'Comfortaa',
    'Courier Prime',
    'Covered By Your Grace',
    'Crafty Girls',
    'Cutive',
    'Dancing Script',
    'DianaWebber Caps Solid',
    'Fast-Track',
    'FinalParade-Script',
    'Fjalla One',
    'Floral Silhouette',
    'Foresta Monesta Script',
    'Foresta Monesta Serif',
    'Fredericka the Great',
    'Fredoka One',
    'Gettins',
    'Gladiesky',
    'Glory Gluengku Brush',
    'Good Vibes',
    'Graduate',
    'Graduation',
    'Grand Hotel',
    'Great Vibes',
    'Hanover',
    'Homemade Apple',
    'Indie Flower',
    'Josefin Sans',
    'Juliette',
    'Kora',
    'League Script',
    'LEMON MILK',
    'Limelight',
    'Linust',
    'Lobster',
    'Lora',
    'Love Ya Like A Sister',
    'Luxury',
    'Metal Mania',
    'Miss Fajardose',
    'Modak',
    'Monoton',
    'Montserrat',
    'Mouse Memoirs',
    'Mouth Beast',
    'Mrs Saint Delafield',
    'Neonblitz',
    'Open Sans',
    'Pacifico',
    'Parisienne',
    'Permanent Marker',
    'Pinyon Script',
    'Portico Outline',
    'Press Start 2P',
    'PT Serif',
    'Rainy Love',
    'Raleway',
    'Rampart One',
    'Roboto Condensed',
    'Sacramento',
    'Shaun Gilchrist',
    'Sherika',
    'SHIVER',
    'Single',
    'Slackey',
    'Sniglet',
    'Sofia',
    'Sorts Mill Goudy',
    'Spicy Rice',
    'Sports College',
    'Speed-Display',
    'Speed-Rough',
    'SWASH',
    'Travax',
    'Vultron',
    'Vultron-Grunge',
    'WeddingHeart',
    'Alex Brush',
    'Anton',
    'Archivo Black',
    'Astrid',
    'Bailey',
    'Bebas Neue Light',
    'Bebas Neue',
    'Candlescript Demo Version',
    'Caroline',
    'CF Notche',
    'Champignon',
    'Covington',
    'Intro Inline',
    'Leafy',
    'League Spartan',
    'Puzzled',
    'Woman Font',
    'Questrial',
    'AbhayaLibre',
    'accid',
    'ChopinScript',
    'coolvetica rg',
    'Effloresce',
    'Kaoly Demo',
    'Kines-Regular',
    'marguerite',
    'MickeyMouse',
    'pincoyablack',
    'Rostack',
    'Royalacid',
    'SixCaps-Regular',
    'TulpenOne-Regular',
];
